import SubGrupoService from "@/services/SubGrupoService";

export const subGrupo = {
  namespaced: true,
  state: {
    subgrupo: {},
  },
  actions: {
    getSubGrupo({ commit }, payload) {
      return SubGrupoService.GetSubGrupo(payload).then(
        (subgrupo) => {
          return Promise.resolve(subgrupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postSubGrupo({ commit }, payload) {
      return SubGrupoService.PostSubGrupo(payload).then(
        (subgrupo) => {
          return Promise.resolve(subgrupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putSubGrupo({ commit }, payload) {
      return SubGrupoService.PutSubGrupo(payload).then(
        (subgrupo) => {
          return Promise.resolve(subgrupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteSubGrupo({ commit }, payload) {
      return SubGrupoService.DeleteSubGrupo(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getSubGrupoOData({ commit }, payload) {
      return SubGrupoService.GetSubGrupoOData(payload).then(
        (subgrupo) => {
          return Promise.resolve(subgrupo);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default subGrupo;
